module.exports = __webpack_public_path__ + "static/media/city-scape-background.ab39ca09.webp";